import { WEB_COMPONENT_SENSOR_ATLASSIAN_AUDIT } from '../../../../webcomponents.constants';
import { AtlassianAuditComponent } from './component/AtlassianAuditComponent';

export { AtlassianAuditComponent };
window.customElements.define(WEB_COMPONENT_SENSOR_ATLASSIAN_AUDIT, AtlassianAuditComponent);
